module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av747-c269955e7aa13238db5f654dec67f376.jpg";